import { Event, QueryEventArgs } from '@tribeplatform/gql-client/types'
import { EventFields } from '@tribeplatform/gql-client/types/generated'
import {
  useQuery,
  UseQueryOptions,
  useTribeClient,
} from '@tribeplatform/react-sdk'

import { getEventKey } from './event.key.js'

export const useEvent = (options: {
  variables: QueryEventArgs
  fields?: EventFields
  useQueryOptions?: UseQueryOptions<Event>
}) => {
  const { variables, useQueryOptions } = options || {}
  const eventKey = getEventKey({ variables })
  const { client } = useTribeClient()

  return useQuery<Event>(
    eventKey,
    () => client.events.get(variables),
    useQueryOptions,
  )
}
